<script>
import ChecksListDesktopView from "./ChecksListDesktopView.vue";

/**
 * Desktop list layout bridge.
 * Renders ChecksListDesktopView using the parent checks-list instance as
 * context so template bindings and $refs stay on checksList.vue (provide/inject).
 */
export default {
  name: "ChecksListDesktopBridge",
  inject: ["checksList"],
  render() {
    const checksList = this.checksList;
    const viewOptions = ChecksListDesktopView.options || ChecksListDesktopView;
    const render = viewOptions.render;

    if (!checksList || typeof render !== "function") {
      return null;
    }

    const options = checksList.$options;
    const prevStaticRenderFns = options.staticRenderFns;
    const prevScopeId = options._scopeId;

    options.staticRenderFns = viewOptions.staticRenderFns;
    if (viewOptions._scopeId) {
      options._scopeId = viewOptions._scopeId;
    }

    try {
      return render.call(checksList, checksList.$createElement);
    } finally {
      options.staticRenderFns = prevStaticRenderFns;
      options._scopeId = prevScopeId;
    }
  },
};
</script>
